module.exports = __webpack_public_path__ + "static/breakfast-df4d98536173fdf0e2f4e30f784ac090.mp3";